export { default as Avatar } from './Avatar';
export type { Color } from './colorsMap';
